import FormInputWithLabel from '../form/FormInputWithLabel';

export default function SinglePatientInfo({patientsData, handleChange}) {
  const GENDER_OPTIONS = ['Male', 'Female', 'Others', 'Decline to State'];

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        gap: '3px',
        backgroundColor: '#f7f7f7',
        borderRadius: '6px',
        padding: '16px 8px'
      }}>
      <FormInputWithLabel label='Patient ID' name='patientId' value={patientsData.p_uhid} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />

      {/* Patient Name */}
      <FormInputWithLabel
        label='Patient Name'
        name='patientName'
        value={`${patientsData.titles} ${patientsData.first_name} ${patientsData.last_name}`}
        required={false}
        onChange={handleChange}
        inputClassName='show'
        minWidth='140px'
      />

      {/* Gender */}
      <div className='d-flex align-items-center'>
        <label className='fw-semibold mb-0' style={{width: '120px', display: 'inline-block', verticalAlign: 'middle'}}>
          Gender
        </label>
        <span className='fw-semibold ps-4 pe-2 pt-2'>:</span>
        <div className={`flex-grow-1`} style={{position: 'relative'}}>
          <select
            name={`gender`}
            value={patientsData.gender}
            onChange={handleChange}
            style={{
              border: '1px solid #ddd',
              outline: 'none',
              padding: '10px',
              marginLeft: '10px',
              width: '226px',
              backgroundColor: 'white'
            }}>
            <option value='' disabled>
              Select Gender
            </option>
            {GENDER_OPTIONS.map(gender => (
              <option key={gender} value={gender}>
                {gender}
              </option>
            ))}
          </select>
        </div>
      </div>

      <FormInputWithLabel label='Age' name='age' value={patientsData.age} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
    </div>
  );
}
